import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface RightProps {
  children?: ReactNode;
  className?: string;
  hidden?: boolean;
}

export const Right = ({ className, children, hidden = false }: RightProps) => {
  if (hidden) {
    return null;
  }

  return (
    <aside
      aria-label={t("right_sidebar")}
      className={classNames(
        anchorClassNames("sidebar sidebar--right"),
        className,
      )}
      data-testid="sidebar-right"
    >
      <div
        className={anchorClassNames("sidebar__content")}
        data-draggable="false"
      >
        {children}
      </div>
    </aside>
  );
};
